import client from "./client";

export function getDepartmentSchedules(
  year = null,
  month = null,
  scheduleTypeId = null,
  userId = null,
) {
  let params = year && month ? `?year=${year}&month=${month}` : "";
  if (scheduleTypeId) {
    params += `&schedule_type_id=${scheduleTypeId}`;
  }
  if (userId) {
    params += `&user_id=${userId}`;
  }

  return client
    .get(`/api/department_schedules/${params}`)
    .then((res) => res.data);
}

export function getSchedulesByDate(date) {
  const params = `?year=${date.year()}&month=${
    date.month() + 1
  }&day=${date.date()}`;

  return client
    .get(`/api/department_schedules/${params}`)
    .then((res) => res.data);
}

export function addDepartmentSchedule(body) {
  return client
    .post("/api/department_schedules/", body)
    .then((res) => res.data);
}

export function setDepartmentSchedule(body) {
  return client
    .put(`/api/department_schedules/${body.id}/`, body)
    .then((res) => res.data);
}

export function deleteDepartmentSchedule(body) {
  return client
    .delete(`/api/department_schedules/${body.id}/`)
    .then((res) => res.data);
}
